import { useState, useEffect } from "react";

export default function useSlider(slides) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const totalSlides = slides.length;

  const updateSlider = (index) => {
    setCurrentIndex((index + totalSlides) % totalSlides);
  };

  useEffect(() => {
    const autoSlide = setInterval(() => {
      updateSlider(currentIndex + 1);
    }, 10000);

    return () => clearInterval(autoSlide);
  }, [currentIndex]);

  return {
    currentIndex,
    updateSlider,
  };
}
